import MyPartnerPage from '@playground/features/partner-team/MyPartnerPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_partner/my-partner')({
  component: MyPartnerPage,
})
